import { Link } from "@tanstack/react-router";
import { useCrossConceptSuggestions } from "@/hooks/useCrossConceptSuggestions";

interface Props {
  conceptId: string;
  paperId: string;
}

export function CrossConceptSuggestions({ conceptId, paperId }: Props) {
  const { data } = useCrossConceptSuggestions(conceptId, paperId);

  if (!data?.suggestions.length) return null;

  return (
    <div>
      <p className="mb-1 text-xs font-medium text-muted-foreground">
        Also relevant to
      </p>
      <div className="flex flex-wrap gap-1.5">
        {data.suggestions.map((s) => (
          <Link
            key={s.concept_id}
            to="/concepts/$conceptId/curate"
            params={{ conceptId: s.concept_id }}
            className="inline-flex items-center gap-1 rounded-full border px-2 py-0.5 text-xs text-muted-foreground transition-colors hover:border-[#89b4fa] hover:text-[#89b4fa]"
          >
            {s.concept_name}
            <span className="text-[10px] opacity-60">
              {s.papers.length} paper{s.papers.length !== 1 ? "s" : ""}
            </span>
          </Link>
        ))}
      </div>
    </div>
  );
}
